import { StandardEvents } from '@shopify/events';

// Alert Me supplies the email workflow; Horizon remains responsible for purchasing.
const initial = document.getElementById('soz-restock-variant-context');
if (initial) {
  let context;
  try { context = JSON.parse(initial.textContent); } catch { context = null; }
  if (context) initRestock(context);
}

function initRestock(context) {
  let productId = String(context.productId);
  let variant = context.variant;
  let generation = 0;
  let state = 'unavailable';
  let popupGeneration = null;
  let scheduled = false;

  function mainForm() {
    return [...document.querySelectorAll('#MainContent product-form-component')].find(
      (form) => form.dataset.productId === productId && !form.closest('product-card, quick-add-dialog')
    );
  }

  function render(nextState) {
    state = nextState;
    document.body.dataset.sozRestockState = state;
    const form = mainForm();
    if (!form) return;
    form.dataset.sozRestockMain = 'true';
    form.dataset.sozRestockState = state;
    form.dataset.sozRestockVariantId = variant?.id ? String(variant.id) : '';
    let status = form.querySelector('[data-soz-restock-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.sozRestockStatus = '';
      status.className = 'soz-restock-status';
      status.setAttribute('role', 'status');
      form.querySelector('form')?.prepend(status);
    }
    status.hidden = state !== 'restock';
    status.textContent = 'Temporarily out of stock in this option.';
  }

  function resolvedState(resource) {
    if (!resource?.id) return 'unavailable';
    return resource.available === false ? 'restock' : 'available';
  }

  function syncPopup() {
    if (state !== 'restock' || popupGeneration !== generation || !variant?.id) return;
    const select = document.getElementById('notifyVariantSelect');
    const modal = document.getElementById('notifyMeModal');
    if (!select || !modal || modal.style.display === 'none') return;
    const selected = [...select.options].find((option) => option.value === String(variant.id));
    // Never invent an app-excluded/unknown variant or subscribe to a different one.
    if (!selected) {
      modal.style.display = 'none';
      popupGeneration = null;
      return;
    }
    if (select.value !== selected.value) {
      select.value = selected.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener(StandardEvents.productSelect, async (event) => {
    const picker = event.target instanceof Element ? event.target.closest('variant-picker') : null;
    const form = mainForm();
    if (!picker?.hasAttribute('data-template-product-match') || picker.closest('product-card, quick-add-dialog') ||
        picker.closest('.shopify-section') !== form?.closest('.shopify-section')) return;
    const current = ++generation;
    popupGeneration = null;
    const modal = document.getElementById('notifyMeModal');
    if (modal && modal.style.display !== 'none') modal.style.display = 'none';
    render('pending');
    try {
      const { detail } = await event.promise;
      if (current !== generation) return;
      if (detail?.newProduct?.id && String(detail.newProduct.id) !== productId) {
        // The app owns its original product context; do not notify a different combined listing.
        variant = null;
        render('unavailable');
        return;
      }
      if (!detail || (detail.productId && String(detail.productId) !== productId)) {
        variant = null;
        render('unavailable');
        return;
      }
      variant = detail.resource;
      render(resolvedState(variant));
    } catch {
      if (current !== generation) return;
      variant = null;
      render('unavailable');
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('#notifyMeButton, #floatingButton') : null;
    if (!button) return;
    if (state !== 'restock' || !variant?.id || String(button.dataset.productId) !== productId) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    popupGeneration = generation;
    // The app builds/populates its modal synchronously in the target click handler.
    queueMicrotask(syncPopup);
  }, true);

  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof HTMLFormElement) || event.target.id !== 'notifyMeForm') return;
    syncPopup();
    const select = event.target.querySelector('#notifyVariantSelect');
    const matches = select && [...select.options].some((option) => option.value === String(variant?.id)) &&
      select.value === String(variant?.id);
    if (state !== 'restock' || !variant?.id || popupGeneration !== generation || !matches) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  // App injection and Horizon morphs can happen after initial render. Do not poll or
  // fight the app's inline display rules; the scoped parent CSS controls visibility.
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(() => {
      scheduled = false;
      const form = mainForm();
      if (form && form.dataset.sozRestockMain !== 'true') render(state);
      syncPopup();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  render(resolvedState(variant));
}
